import { AssetsLayout } from './components/AssetsLayout';

/**
 * 资产库页面
 */
export default function AssetsPage() {
  return <AssetsLayout />;
}
